var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"text-center d-flex align-center",attrs:{"no-gutters":""}},[_c('home-view'),_c('v-overlay',{attrs:{"value":_vm.ticketsLoading,"absolute":true}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"64"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }